import React from "react";
// Ensure your video path is correct
import videoSrc from '../Assest/videos/grocryStoreVideo.mp4'; 

const Video = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background video */}
      <video
        src={videoSrc}
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content over the video */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
        <span className="text-[#f36812] font-semibold tracking-[0.2em] uppercase mb-4">
          Fresh. Healthy. Delivered.
        </span>
        <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight drop-shadow-lg">
          Everything You Need <br /> In <span className="text-[#f36812]">One Place</span>
        </h1>
        <p className="text-lg sm:text-xl mt-6 max-w-xl text-gray-200">
          From farm-fresh vegetables and daily essentials to pantry staples, we deliver quality to your doorstep.
        </p>
        
        <div className="flex gap-4 mt-10">
          <button 
            className="px-8 py-3 bg-[#f36812] hover:bg-[#e05a00] text-white font-semibold rounded-lg transition-all duration-300 shadow-lg"
          >
            Start Shopping
          </button>
          <button 
            className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-semibold rounded-lg transition-all duration-300 border border-white/20"
          >
            Our Deals
          </button>
        </div>
      </div>
    </div>
  );
};

export default Video;